import React, { useState, useEffect, Suspense, lazy } from "react";
import LoadingBar from 'react-top-loading-bar'
import axios from "axios";
import {Helmet} from "react-helmet";
import { Markup } from 'interweave';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import Sidebar from "../Sidebar/Sidebar";
// import Category from "./Category/Category";
// import RecentVideos from "./RecentVideos/RecentVideos";
import styles from "../../App.module.css";
import './Homepage.css';
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Spinner from "../Global/Spinner";

import ChannelBox from '../Global/ChannelBox';
import VideoBox from '../Global/VideoBox';
import MusicBox from '../Global/MusicBox';
import ImageBox from '../Global/ImageBox'
import SingleGroup from "../Global/SingleGroup";
import SingleWeblink from '../Global/SingleWeblink'

const TopChannels = lazy(() => import('./TopChannels/TopChannels'));
const FeaturedVideos = lazy(() => import('./FeaturedVideos/FeaturedVideos'));

var owlSettings = {
  dots: false,
  autoplay: true,
  margin: 12,
  autoplayTimeout: 3000,
  autoplayHoverPause: true,
  nav: true,
  loop: true,
  lazyLoad:true,
  responsive: {
    0: {
      items: 1
    },
    600: {
      items: 3
    },
    1000: {
      items: 6
    }
  },
  theme: 'owl-theme',
}

var videoOwlSettings = {
  dots: false,
  lazyLoad:true,
  margin: 24,
  nav: true,
  responsive: {
    0: {
      items: 1
    },
    600: {
      items: 2
    },
    900: {
      items: 3
    },
    1200: {
      items: 4
    }
  },
}
var ImageOwlSettings = {
  dots: false,
  lazyLoad:true,
  margin: 24,
  nav: true,
  responsive: {
    0: {
      items: 1
    },
    600: {
      items: 2
    },
    900: {
      items: 3
    },
    1200: {
      items: 4
    }
  },
}

function Homepage() {
  const [progress, setProgress] = useState(100);
  const [blocks, setBlocks] = useState([]);

  useEffect(() => {
    try{
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }catch(ex){}
  }, []);

  useEffect(() => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/home.php`, {
      progress: progress,
    }, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }).then(res => {
      // console.log(res.data);
      setBlocks(res.data);
    })
  }, [])

  return (
    <>
      <Helmet>
          <title>Wesharez</title>
          <meta name="description" content="Share your web pages, articles, blog entries, photographs, and videos with friends, family, and the world on Wesharez." />
          <meta name="keywords" content="wesharez, youtube videos, musics, images, albums, earn money, Bookmarking, be a creator, share video, share your content, products, services, products and services, blog, latest articles, web pages, views, skin, science, days, review" />
      </Helmet>
      <LoadingBar
        color='#f11946'
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      <Header />
      <div className={styles.main_body}>
        <Sidebar active="home" />
        <div className={styles.main_content + ` main-content`}>
          <ins className='adsbygoogle m-4'
            style={{ display: 'block' }}
            data-ad-client='ca-pub-8126596259429304'
            data-ad-slot='5153011292'
            data-ad-format='auto'
          />
          <Suspense fallback={<div className="text-center py-5"><Spinner /></div>}>
            {/* <TopChannels /> */}
            {/* <FeaturedVideos /> */}
            {
              blocks && blocks.map && blocks.map((block, index) => {
                const arr = Object.entries(block)[0][1];
                
                if(arr.type === 'channels-carousel') {
                  return (
                    <div className="channels m-4">
                      {
                        arr.title !== '' && <div className="section_name">
                          <h4>{arr.title}</h4>
                        </div> 
                      }
                      {
                        <OwlCarousel className='owl-theme' margin={0}  { ...owlSettings } >
                          {
                            arr.content && arr.content.map && arr.content.map((channel, index) => {
                              return(
                                ChannelBox(channel, false)
                              )
                            })
                          }
                        </OwlCarousel>
                      }
                    </div>
                  )
                }
                if(arr.type === 'videos-carousel') {
                  return (
                    <div className="videos p-4">
                      {
                        arr.title !== '' && <div className="section_name">
                          <h4>{arr.title}</h4>
                        </div> 
                      }
                      {
                        <OwlCarousel className='owl-theme' margin={0}  { ...videoOwlSettings } >
                          {
                            arr.content && arr.content.map && arr.content.map((channel, index) => {
                              return(
                                VideoBox(channel)
                              )
                            })
                          }
                        </OwlCarousel>
                      }
                    </div>
                  )
                }
                if(arr.type === 'images-carousel') {
                  return (
                    <div className={`${styles.gallery} p-4`}>
                      {
                        arr.title !== '' && <div className="section_name">
                          <h4>{arr.title}</h4>
                        </div> 
                      }
                      {
                        <OwlCarousel className='owl-theme' margin={0}  { ...videoOwlSettings } >
                          {
                            arr.content && arr.content.map && arr.content.map((image, index) => {
                              return(
                                <div className={styles.item} key={index}>
                                  {
                                    ImageBox(image)
                                  }
                                </div>
                              )
                            })
                          }
                        </OwlCarousel>
                      }
                    </div>
                  )
                }
                if(arr.type === 'videos-loop') {
                  return (
                    <div className="p-4">
                      <div className="row">
                        {
                          arr.title !== '' && <div className="section_name">
                            <h4>{arr.title}</h4>
                          </div> 
                        }
                        {
                          arr.content && arr.content.map && arr.content.map((video, index) => {
                            return(
                              <div key={index} className="col-lg-3 col-sm-6">
                                {
                                  VideoBox(video)
                                }
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  )
                }
                if(arr.type === 'music-loop') {
                  return (
                    <div className="p-4">
                      <div className="row">
                        {
                          arr.title !== '' && <div className="section_name">
                            <h4>{arr.title}</h4>
                          </div> 
                        }
                        {
                          arr.content && arr.content.map && arr.content.map((video, index) => {
                            return(
                              <div key={index} className="col-md-8">
                                {
                                  MusicBox(video)
                                }
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  )
                }
                if(arr.type === 'images-loop') {
                  return (
                    <div className={`${styles.gallery} p-4`}>
                      <div className="row">
                        {
                          arr.title !== '' && <div className="section_name">
                            <h4>{arr.title}</h4>
                          </div> 
                        }
                        {
                          arr.content && arr.content.map && arr.content.map((image, index) => {
                            return(
                              <div className={`${styles.item} col-lg-3 col-md-4 col-6 col-sm`} key={index}>
                                {
                                  ImageBox(image)
                                }
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  )
                }
                if(arr.type === 'groups-loop') {
                  return (
                    <div className="p-4">
                      {
                        arr.title !== '' && <div className="section_name">
                          <h4>{arr.title}</h4>
                        </div> 
                      }
                      <div className={styles.groups}>
                        {
                          arr.content && arr.content.map && arr.content.map((image, index) => {
                            return(
                              <div key={index}>
                                {
                                  SingleGroup(image)
                                }
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  )
                }
                if(arr.type === 'weblinks-loop') {
                  return (
                    <div className="p-4">
                      {
                        arr.title !== '' && <div className="section_name">
                          <h4>{arr.title}</h4>
                        </div> 
                      }
                      <div className={styles.weblinks}>
                        {
                          arr.content && arr.content.map && arr.content.map((image, index) => {
                            return(
                              <div key={index}>
                                {
                                  SingleWeblink(image)
                                }
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  )
                }
                if(arr.type === 'html') {
                  return (
                    <div className='p-4'>
                      {
                        arr.title !== '' && <div className="section_name">
                          <h4>{arr.title}</h4>
                        </div>
                      }
                      <Markup content={arr.content} />
                    </div>
                  )
                }
              })
            }
            <Footer />
          </Suspense>
        </div>
      </div>
    </>
  )
}

export default Homepage;
